// アプリ版 src/lib/Identification.js と同じ定義
export const identificationTypes = {
  driverLicense: {
    name: '運転免許証／運転経歴証明書',
    alert:
      '障害や病歴がわかる情報や臓器提供意思の記載がある場合は、ふせん等で隠してから撮影してください',
    useBack: true,
    frontLabel: '表面',
    backLabel: '裏面',
  },
  myNumberCard: {
    name: 'マイナンバーカード',
    alert: '裏面の個人番号およびQRコードをふせん等で隠してから撮影してください',
    useBack: false,
    frontLabel: '表面',
    backLabel: '裏面',
  },
  residenceCard: {
    name: '在留カード',
    alert: null,
    useBack: true,
    frontLabel: '表面',
    backLabel: '裏面',
  },
  passport: {
    name: '日本国パスポート',
    alert: '2020年2月以降に発行された新パスポートはご利用いただけません',
    useBack: true,
    frontLabel: '顔写真ページ',
    backLabel: '所持人記入欄',
  },
  studentCard: {
    name: '学生証',
    alert: null,
    useBack: true,
    frontLabel: '表面',
    backLabel: '裏面',
  },
};

export const identificationMenu = [
  { title: '運転免許証／運転経歴証明書', type: 'driverLicense' },
  { title: 'マイナンバーカード', type: 'myNumberCard' },
  { title: '在留カード', type: 'residenceCard' },
  { title: '日本国パスポート', type: 'passport' },
  { title: '学生証', type: 'studentCard' },
];
